import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  mainContainer: {
    marginTop: 6,
    padding: 10,
    width: 340,
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
  },

  logoCalculadora: {
    width: 70,
    height: 95,
    marginRight: 10,
  },

  textContainer: {
    flex: 1,
    justifyContent: "center",
  },

  txtTitle: {
    fontWeight: "bold",
    color: "#077A97",
    fontSize: 20,
    marginBottom: 4,
  },

  txtDescricao: {
    textAlign: "justify",
    color: "#333",
  },

  txtBtnCalcular: {
    color: "#fff",
    textAlign: "center",
    textTransform: "uppercase",
  },

  btnCalcular: {
    padding: 10,
    width: 320,
    height: 38,
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginTop: 12,
    color: "#fff",
  },
});
export default styles;
